//TODO: consider removing this with the new payment way import { useParams } from "react-router-dom"
import { Header } from "../../common/header";
import { Footer } from "../main-page/footer";
//TODO: consider removing this with the new payment way import { useSubscriptionService } from "../../../services/subscriptions";
import { NotificationProvider } from "../../../contexts/notification-context";
import { useRouteNavigation } from "../../../lib/common/routes";

export const SubscriptionOKLab = () => {
    //TODO: consider removing this with the new payment way const { subscriptionPlanId, checkoutsessionid } = useParams();
    //TODO: consider removing this with the new payment way const intSubscriptionPlanId = parseInt(subscriptionPlanId || "-1", 10);
    const { getRoute, navigateRouteClickHandler } = useRouteNavigation();

    //TODO: consider removing this with the new payment way const { savePaymentInfo } = useSubscriptionService();

    //TODO: consider removing this with the new payment way savePaymentInfo(checkoutsessionid as string, intSubscriptionPlanId);

    return (
        <>
            <div className="bg-dark">
                <NotificationProvider>
                    <Header title="" />
                </NotificationProvider>
                <div className="container-fluid text-white welcome-abroad-bg welcome-abroad-bg__lab">
                    <div className="container">
                        <div className="row text-center pb-5 justify-content-center">
                            <h2>
                                <strong>Welcome Aboard</strong>
                            </h2>
                            <h2>
                                <strong>Let's Start Building</strong>
                            </h2>
                            <h2>
                                <strong>Your Best Team Ever</strong>
                            </h2>
                            <br />
                            <a
                                className="btn btn-primary rounded-3 w-50"
                                onClick={(e) =>
                                    navigateRouteClickHandler("dashboardLab", e)
                                }
                                href={getRoute("dashboardLab")}
                            >
                                Open My Dashboard
                            </a>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};
